import React from 'react';
import PropTypes from 'prop-types';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import ClientSideTable from '../../shared/ClientSideTable';
import {
  cellDateOperation,
  cellNumOperation,
  cellOperation,
  headerDoubleRowOperation,
  headerOperation,
} from '../../../helpers/tables';
import { fdate } from '../../../helpers/helpers';
import { API, BASE_URL } from '../../../CONST';
import GridContainer from '../../shared/GridContainer';
import DownloadBtn from '../../shared/DownloadBtn';
import TableLink from '../../shared/TableLink';

const CorredorLiquidacionDetalleTable = ({ liquidacionId, periodo, pagos, corredor, tipo }) => {
  const xlsxUrl = `${BASE_URL}${API.liquidacion}/${liquidacionId}/download_detail_xlsx/`;
  const finalXlsxUrl = corredor ? `${xlsxUrl}?corredor_id=${corredor.id}` : xlsxUrl;
  const pdfUrl = `${BASE_URL}${API.liquidacion}/${liquidacionId}/download_detail_pdf/`;
  const finalPdfUrl = corredor ? `${pdfUrl}?corredor_id=${corredor.id}` : pdfUrl;

  const columns = [
    {
      Header: headerOperation('Número Póliza'),
      id: 'nemotecnico',
      accessor: 'poliza.nemotecnico',
      Cell: (row) => cellOperation(row.value),
      minWidth: 120,
    },
    {
      Header: headerDoubleRowOperation('Fecha de', 'Emisión'),
      id: 'fecha_emision',
      accessor: 'poliza.fecha_emision',
      Cell: (row) => cellDateOperation(row.value),
      filterMethod: (filter, row) => fdate(row.fecha_emision).includes(filter.value),
      minWidth: 120,
    },
    {
      Header: headerDoubleRowOperation('Inicio', 'Cobertura'),
      id: 'inicio_vigencia',
      accessor: 'poliza.inicio_vigencia',
      Cell: (row) => cellDateOperation(row.value),
      filterMethod: (filter, row) => fdate(row.inicio_vigencia).includes(filter.value),
      minWidth: 120,
    },
    {
      Header: headerDoubleRowOperation('Fin', 'Cobertura'),
      id: 'termino_vigencia',
      accessor: 'poliza.termino_vigencia',
      Cell: (row) => cellDateOperation(row.value),
      filterMethod: (filter, row) => fdate(row.termino_vigencia).includes(filter.value),
      minWidth: 120,
    },
    {
      Header: headerOperation('Período'),
      id: 'periodo',
      Cell: () => cellOperation(periodo.substring(0, 7)),
      filterable: false,
      sortable: false,
      minWidth: 100,
    },
    {
      Header: headerDoubleRowOperation('Prima Neta', 'Recaudada ($)'),
      id: 'prima_neta',
      accessor: 'prima_neta',
      Cell: (row) => cellNumOperation(row.value),
      filterable: false,
      minWidth: 120,
    },
    {
      Header: headerOperation('IVA ($)'),
      id: 'iva',
      accessor: 'iva',
      Cell: (row) => cellNumOperation(row.value),
      filterable: false,
      minWidth: 120,
    },
    {
      Header: headerOperation('Prima Bruta ($)'),
      id: 'prima_bruta',
      accessor: 'prima_bruta',
      Cell: (row) => cellNumOperation(row.value),
      filterable: false,
      minWidth: 120,
    },
    {
      Header: headerOperation('Factura'),
      id: 'factura_numero',
      accessor: 'factura_numero',
      Cell: (row) => cellOperation(row.value, 'right'),
      minWidth: 120,
    },
    {
      Header: headerOperation('Comisión (%)'),
      id: 'comision_pct',
      accessor: 'comision_pct',
      Cell: (row) => cellNumOperation(row.value, 'float'),
      filterable: false,
      minWidth: 120,
    },
    {
      Header: headerDoubleRowOperation('Comisión Neta', 'Generada ($)'),
      id: 'comision_neta',
      accessor: 'comision_neta',
      Cell: (row) => cellNumOperation(row.value),
      filterable: false,
      minWidth: 120,
    },
    {
      Header: headerOperation('Acciones'),
      id: 'acciones',
      filterable: false,
      accessor: 'poliza.id',
      Cell: (row) => (
        <div style={{ textAlign: 'center' }}>
          <TableLink title="ver" url={`/corredor/polizas-${tipo}/${row.value}`} icon={faEye} />
        </div>
      ),
    },
  ];
  return (
    <div>
      <div>
        <GridContainer columns="1fr auto auto" gap="10px">
          <div style={{ gridColumnStart: 2 }}>
            <DownloadBtn
              id="xlsx-download"
              text="XLSX"
              tipText="Descargar planilla excel"
              url={xlsxUrl ? finalXlsxUrl : ''}
            />
          </div>
          <div style={{ gridColumnStart: 3 }}>
            <DownloadBtn
              id="pdf-download"
              text="PDF"
              tipText="Descargar PDF"
              url={pdfUrl ? finalPdfUrl : ''}
            />
          </div>
        </GridContainer>
      </div>
      <div className="mt-2">
        <ClientSideTable columns={columns} data={pagos} style={{ maxHeight: '63vh' }} />
      </div>
    </div>
  );
};

CorredorLiquidacionDetalleTable.propTypes = {
  liquidacionId: PropTypes.number.isRequired,
  periodo: PropTypes.string.isRequired,
  pagos: PropTypes.arrayOf(
    PropTypes.shape({
      poliza: PropTypes.shape({
        nemotecnico: PropTypes.string,
        fecha_emision: PropTypes.string,
        inicio_vigencia: PropTypes.string,
        termino_vigencia: PropTypes.string,
      }),
      prima_neta: PropTypes.number,
      iva: PropTypes.number,
      prima_bruta: PropTypes.number,
      factura_numero: PropTypes.number,
      comision_pct: PropTypes.number,
      comision_neta: PropTypes.number,
    }),
  ).isRequired,
  corredor: PropTypes.shape({
    id: PropTypes.number,
  }),
  tipo: PropTypes.oneOf(['credito', 'garantia']).isRequired,
};

CorredorLiquidacionDetalleTable.defaultProps = {
  corredor: null,
};

export default CorredorLiquidacionDetalleTable;
